// gkc_hash_code : 01E7J1BV41XHVJMHH8Y4PHXG7H
export const NOTIFICATION_ACTION = {
  GET_NOTIFICATION_UNREAD: 'NOTIFICATION_ACTION/GET_NOTIFICATION_UNREAD',
  GET_NOTIFICATION_LIST: 'NOTIFICATION_ACTION/GET_NOTIFICATION_LIST',
  GET_DROPDOWN_NOTIFICATIONS: 'NOTIFICATION_ACTION/GET_DROPDOWN_NOTIFICATIONS',
  MARK_NOTIFICATIONS_AS_READ: 'NOTIFICATION_ACTION/MARK_NOTIFICATIONS_AS_READ',
  CHECK_NOTIFICATION_AS_READ: 'NOTIFICATION_ACTION/CHECK_NOTIFICATION_AS_READ',
};
